import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import type { Children, FormNotifications } from '@repo/shared/types';
import { colorPalette } from '@repo/mui-config/color-palette';

interface FieldNotificationWrapperProps extends Children {
  variant: FormNotifications;
}

const variantColors = {
  warning: {
    border: colorPalette.warning.main,
    background: colorPalette.warning.light,
  },
  error: {
    border: colorPalette.error.dark,
    background: colorPalette.error.light,
  },
  default: {
    border: colorPalette.cloud.dark,
    background: colorPalette.cloud.light,
  },
};

export function FieldNotificationWrapper({ children, variant }: FieldNotificationWrapperProps) {
  return (
    <Paper
      data-testid="field-notification-wrapper"
      elevation={0}
      sx={{
        border: `2px solid ${variantColors[variant].border}`,
        paddingX: '16px',
        paddingY: '10px',
        borderRadius: '12px',
        backgroundColor: variantColors[variant].background,
      }}
    >
      <Stack alignItems="center" direction="row" gap={3}>
        {children}
      </Stack>
    </Paper>
  );
}
